export default ({ request }) => ({
  orderPlanNoticeListApi(data = {}) {
    return request({
      url: '/factory/production/orderPlanNoticeList',
      method: 'post',
      data
    })
  }
})
